import { BlobProvider } from '@react-pdf/renderer'
import React from 'react'
import DownloadPdf from './pdf/DownloadPdf'

export default function test() {
  return (
    <>
    <div style={{color:'#476b6b99'}}>test</div>
    <BlobProvider document={<DownloadPdf/>}>
        {({ url }) => (
        <a href={url} target="_blank">
            Print
        </a>
        )}
    </BlobProvider>
    </>
  )
}
